module.exports = __webpack_public_path__ + "assets/img/free_10.8d8aa9d8.png";